import React, { useState , useEffect} from 'react';
import Form from "react-bootstrap/Form";
import {Button} from "react-bootstrap";

function LeveragePicker(props) {

    const leveragePicklist = ["1", "2", "3", "4", "5", "10", "20"];

    useEffect(() => {
    }, []);

    return (
        <Form.Group className="mb-3">
            <Form.Label>Leverage</Form.Label>
            <div className="d-flex">
                {(leveragePicklist.map((lev, idx) => (
                    <Button
                        key={lev}
                        variant={props.leverage === lev ? "primary" : "outline-primary"}
                        active={props.leverage === lev}
                        onClick={() => props.setLeverage(lev)}
                        className={idx !== (leveragePicklist.length - 1) ? "w-100 border-end-0 rounded-0" : "w-100 rounded-0"}
                        style={{borderRadius: idx === 0 ? "0.375rem 0 0 0.375rem" : idx === 4 ? "0 0.375rem 0.375rem 0" : "0"}}
                    >
                        {lev}x
                    </Button>
                )))}
            </div>
        </Form.Group>
    );
}

export default LeveragePicker;